module.exports = "https://img.xiyuyouxi.com/saas/img/sign_income.2c5eef8c.png";